// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Chip_wrap__ATEzw","active":"Chip_active__pOFNi"};